import {
  ALBUM_LIST_LOADING,
  GET_ALBUM_LIST_ERROR,
  GET_ALBUM_LIST,
  GET_ALBUM_BY_ID_LOADING,
  GET_ALBUM_BY_ID_SUCCESS,
  GET_ALBUM_BY_ID_ERROR,
  DELETEING_ALBUM,
  DELETE_ALBUM,
  DELETE_ALBUM_ERROR,
  DELETED_ALBUM_LIST_LOADING,
  GET_DELETED_ALBUM_LIST,
  GET_DELETED_ALBUM_LIST_ERROR,
  PERMA_DELETEING_ALBUM,
  PERMA_DELETE_ALBUM,
  PERMA_DELETE_ALBUM_ERROR,
  RESTORE_ALBUM_LIST_LOADING,
  RESTORE_ALBUM_LIST,
  RESTORE_ALBUM_LIST_ERROR,
} from "./types";

const INITIAL_STATE = {
  data: undefined,
  loading: false,
  error: false,
  dataById: undefined,
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ALBUM_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_ALBUM_BY_ID_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case DELETEING_ALBUM:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case DELETED_ALBUM_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case PERMA_DELETEING_ALBUM:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case RESTORE_ALBUM_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case GET_ALBUM_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };
    case GET_ALBUM_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        dataById: action.payload.data,
        error: false,
      };
    case GET_DELETED_ALBUM_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };
    case DELETE_ALBUM:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };

    case PERMA_DELETE_ALBUM:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };
    case RESTORE_ALBUM_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };

    case GET_ALBUM_LIST_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case GET_ALBUM_BY_ID_ERROR:
      return {
        ...state,
        dataById: undefined,
        loading: false,
        error: action.payload.data,
      };
    case GET_DELETED_ALBUM_LIST_ERROR:
      return {
        ...state,
        dataById: undefined,
        loading: false,
        error: action.payload.data,
      };
    case DELETE_ALBUM_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case PERMA_DELETE_ALBUM_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case RESTORE_ALBUM_LIST_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };

    default:
      return state;
  }
};

export default reducer;